export default [
  {
    name: "aiMailsAdmin",
    path: "/ai/mails/admin",
    meta: { rights: ["ai_mail_admin", "g_manageRights"], hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "ai-mails" */ "@/views/ai/mails/AiMailsAdminView.vue"),
  },
  {
    name: "aiMails",
    path: "/ai/mails",
    meta: { rights: ["ai_mail", "ai_mail_admin", "g_manageRights"], hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "ai-mails" */ "@/views/ai/mails/AiMailsView.vue"),
  },
  {
    name: "aiMail",
    path: "/ai/mail",

    meta: { rights: ["ai_mail"], hideBottomNavigation: true, hideAppBar: true, fullWidth: true },

    component: () => import("@/views/ai/mail/aiMailView.vue"),
  },
  {
    name: "aiChat",
    path: "/ai/chat",

    meta: { rights: ["ai_mail"], hideBottomNavigation: true, hideAppBar: true, fullWidth: true, backgroundColor: "#212121" },

    component: () => import("@/views/ai/chat/chatView.vue"),
  },
]
